import { Featured } from '@skinsoft/types'
import { Observable } from 'rxjs'
import { defineComponent, PropType } from 'vue'

import { DataStore, map } from '@skinsoft/data-store'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { FeaturedList } from '../featured-list'
import { DELETE_CARD } from '@skinsoft/events'

const FEATURED_ITEM_COUNT = 3

export const EntityFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sFeaturedList: FeaturedList,
    },
    props: {
        // entityDataStore/serializer are shared across many entity types (item/movement/task/...),
        // so a generic base type is the honest type here, not a stand-in for a missing precise one.
        entityDataStore: {
            type: Object as PropType<DataStore<any, any>>,
            required: true,
        },
        featuredStates: {
            type: Array as PropType<string[]>,
            required: true,
        },
        sortFields: {
            type: Array as PropType<string[]>,
            required: true,
        },
        serializer: {
            type: Function as PropType<(entity: any) => Observable<any>>,
            required: true,
        },
        targetRouteName: String,
        sortAsc: {
            type: Boolean,
            default: true
        },
        customCard: {
            //type: Vue.Component
        },
        customCardProps: {
            type: Object,
        }
    },
    template: require('./entity-featured-list.html'),
    data() {
        return {
            featureds: Array(FEATURED_ITEM_COUNT).fill(null) as Array<Featured | null>,
            DELETE_CARD,
        }
    },
    created() {
        this.subscribe();
    },
    methods: {
        onFeaturedClik([featured]: [Featured]) {
            if (!featured) {
                // still loading
                return;
            }

            const index = this.featureds.findIndex(i => (i as Featured).id === featured.id);
            const next = this.featureds.filter((_, k) => k > index).map(v => (v as Featured).id);
            const query: Record<string, string> = next ? { next: next as any } : {};

            const params: Record<string, string> = { id: featured.id };

            return this.$router.push({ name: this.targetRouteName, params, query });
        },
        subscribe() {
            this.subscribeTo(
                this.entityDataStore
                    .fetchAll({
                        query: {
                            ...(this.featuredStates.length > 0 && {
                                states: this.featuredStates.join(','),
                            }),
                            sortAsc: `${!this.sortAsc}`,
                            ...(this.sortFields.length > 0 && {
                                sortFields: this.sortFields.join(','),
                            }),
                        },
                    })
                    .pipe(map(this.serializer)),
                (featureds: Featured[]) => {
                    this.featureds = featureds;
                    (this.featureds as Featured[]).sort((a: Featured, b: Featured) => {
                        const aIndex = this.featuredStates.indexOf(a.state);
                        const bIndex = this.featuredStates.indexOf(b.state);

                        if (aIndex > bIndex) {
                            return 1;
                        }

                        if (aIndex === bIndex) {
                            return 0;
                        }

                        return -1;
                    });
                },
                'featureds',
            );
        },
        onDeleteEntity(id: string) {
            this.entityDataStore.delete(id).subscribe(() => {
                this.unsubscribe()
                this.subscribe()
            })
        },
        unsubscribe() {
            this.unsubscribeFrom('featureds');
        },
    },
    watch: {
        entityDataStore() {
            this.unsubscribe();
            this.subscribe();
        },
    },
})
